













































import CashFlowFilterForm from "@/components/cash-flow-report/CashFlowFilterForm.vue";
import CashFlowReportTable from "@/components/cash-flow-report/CashFlowReportTable.vue";
import CashFlowReportDetailModal from "@/components/cash-flow-report/CashFlowReportDetailModal.vue";
import useBlob from "@/hooks/useBlob";
import MNotificationVue from "@/mixins/MNotification.vue";
import {
  CashFlowPeriodType,
  CashFlowReportResponse,
} from "@/models/interface/cash-flow-report/CashFlowReport.interface";
import {
  buildFilterParams,
  CashFlowReportDownloadParams,
  CashFlowReportFilterParams,
} from "@/models/interface/cash-flow-report/CashFlowReportFilterParams.interface";
import { cashFlowReportService } from "@/services/cash-flow-report.service";
import { Component, Mixins } from "vue-property-decorator";

@Component({
  components: {
    CashFlowFilterForm,
    CashFlowReportTable,
    CashFlowReportDetailModal,
  },
})
export default class CashFlowReportPage extends Mixins(MNotificationVue) {
  reportData: CashFlowReportResponse | null = null;
  loading = {
    find: false,
    download: false,
  };
  currentFilterParams: CashFlowReportFilterParams | null = null;

  get showTotal(): boolean {
    const p = this.currentFilterParams;
    return (
      !!p &&
      p.periodType === CashFlowPeriodType.QUARTERLY &&
      p.quarterCount !== undefined &&
      p.quarterCount >= 2 &&
      p.quarterCount <= 4
    );
  }

  detailModal = {
    visible: false,
    categoryId: "",
    dateFrom: "",
    dateTo: "",
  };

  async handleFind(values: {
    periodType: CashFlowPeriodType;
    year: number;
    month?: number;
    quarterCount?: number;
  }): Promise<void> {
    const { periodType, year, month, quarterCount } = values;

    try {
      this.loading.find = true;
      const params = buildFilterParams(periodType, year, month, quarterCount);
      this.currentFilterParams = params;
      this.reportData = await cashFlowReportService.getReport(params);
    } catch (error) {
      this.showNotifError("notif_error_status_code");
    } finally {
      this.loading.find = false;
    }
  }

  private async handleDownload(
    downloadFn: (params: CashFlowReportDownloadParams) => Promise<Blob>,
    filePrefix: string
  ): Promise<void> {
    if (!this.currentFilterParams || !this.reportData) return;

    const companyName = this.$store.state.authStore.authData.companyName;
    if (!companyName) {
      this.showNotifError("lbl_notif_not_found_company_name");
      return;
    }

    this.loading.download = true;
    try {
      const downloadParams: CashFlowReportDownloadParams = {
        ...this.currentFilterParams,
        params: companyName,
      };

      const blob = await downloadFn(downloadParams);
      const firstDate = this.reportData.columns[0].dateFrom;
      const lastDate =
        this.reportData.columns[this.reportData.columns.length - 1].dateTo;
      const { toDownload } = useBlob();
      toDownload(blob, `${filePrefix}-${firstDate}_${lastDate}.xlsx`);
    } catch (error) {
      this.showNotifError("notif_error_status_code");
    } finally {
      this.loading.download = false;
    }
  }

  async handleDownloadSummary(): Promise<void> {
    await this.handleDownload(
      params => cashFlowReportService.download(params),
      "cash-flow-report-summary"
    );
  }

  async handleDownloadDetail(): Promise<void> {
    await this.handleDownload(
      params => cashFlowReportService.downloadDetail(params),
      "cash-flow-report-detail"
    );
  }

  handleDetailClick({
    categoryId,
    dateFrom,
    dateTo,
  }: {
    categoryId: string;
    dateFrom: string;
    dateTo: string;
  }): void {
    this.detailModal.categoryId = categoryId;
    this.detailModal.dateFrom = dateFrom;
    this.detailModal.dateTo = dateTo;
    this.detailModal.visible = true;
  }

  handleDetailModalClose(): void {
    this.detailModal.visible = false;
  }
}
